import { render, staticRenderFns } from "./ArchiveContentModal.vue?vue&type=template&id=34cfeb30&"
import script from "./ArchiveContentModal.vue?vue&type=script&lang=js&"
export * from "./ArchiveContentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports